import { Pill } from "./ui";
import { Ic } from "./icons";

export const Cadastre = ({
  className = "",
  highlight = true,
}: {
  className?: string;
  highlight?: boolean;
}) => (
  <div className={`relative rounded-xl2 overflow-hidden map-grid hairline ${className}`}>
    <svg viewBox="0 0 300 200" className="absolute inset-0 w-full h-full">
      <path
        d="M-10 60 L310 40"
        stroke="rgba(20,22,26,0.18)"
        strokeWidth="14"
        strokeLinecap="round"
      />
      <path
        d="M-10 60 L310 40"
        stroke="#F4F4EF"
        strokeWidth="11"
        strokeLinecap="round"
      />
      <path
        d="M60 -10 L80 220"
        stroke="rgba(20,22,26,0.18)"
        strokeWidth="10"
        strokeLinecap="round"
      />
      <path
        d="M60 -10 L80 220"
        stroke="#F4F4EF"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <g
        stroke="rgba(20,22,26,0.35)"
        strokeWidth="0.8"
        fill="rgba(255,255,255,0.6)"
      >
        <path d="M90 70 L160 68 L162 110 L92 112 Z" />
        <path d="M165 68 L230 66 L232 108 L167 110 Z" />
        <path d="M235 66 L290 64 L292 104 L237 106 Z" />
        <path d="M92 116 L162 114 L164 156 L94 158 Z" />
        <path d="M236 110 L290 108 L292 148 L238 150 Z" />
      </g>
      <g>
        <path
          d="M167 114 L232 112 L234 154 L169 156 Z"
          fill={highlight ? "rgba(217,234,44,0.55)" : "rgba(255,255,255,0.7)"}
          stroke="#14161A"
          strokeWidth="1.4"
          className="dashed-parcel"
        />
        <path
          d="M182 124 L218 122 L219 142 L183 144 Z"
          fill="rgba(20,22,26,0.85)"
          stroke="rgba(20,22,26,0.85)"
        />
        <text
          x="201"
          y="137"
          textAnchor="middle"
          fontSize="7"
          fill="#F5FCAA"
          fontFamily="JetBrains Mono"
        >
          145 m²
        </text>
      </g>
      <g transform="translate(16,180)">
        <rect x="0" y="0" width="40" height="3" fill="#14161A" />
        <text
          x="44"
          y="5"
          fontSize="7"
          fill="#14161A"
          fontFamily="JetBrains Mono"
        >
          10 m
        </text>
      </g>
    </svg>
    <div className="absolute top-3 left-3">
      <Pill tone="soft" icon={<Ic.Pin size={12} />}>
        Parcelle AB-0147
      </Pill>
    </div>
  </div>
);
